"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _modalTitle = _interopRequireDefault(require("./modal-title"));
var _modalHeader = _interopRequireDefault(require("./modal-header"));
var _modalBody = _interopRequireDefault(require("./modal-body"));
var Modal = function Modal(_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$fullScreen = _ref.fullScreen,
    fullScreen = _ref$fullScreen === void 0 ? false : _ref$fullScreen,
    _ref$fullSizeBody = _ref.fullSizeBody,
    fullSizeBody = _ref$fullSizeBody === void 0 ? false : _ref$fullSizeBody,
    children = _ref.children,
    _ref$ariaHideApp = _ref.ariaHideApp,
    ariaHideApp = _ref$ariaHideApp === void 0 ? true : _ref$ariaHideApp,
    ariaContentLabel = _ref.ariaContentLabel,
    ariaContentLabelledBy = _ref.ariaContentLabelledBy,
    onAfterOpen = _ref.onAfterOpen,
    onRequestClose = _ref.onRequestClose,
    onAfterClose = _ref.onAfterClose;
  return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
    isOpen: isOpen,
    ariaHideApp: ariaHideApp,
    closeTimeoutMS: 200,
    portalClassName: (0, _classnames["default"])('modal', {
      'modal_fullscreen': fullScreen,
      'modal_fullsize': fullSizeBody
    }),
    overlayClassName: {
      base: 'modal__overlay',
      afterOpen: 'modal__overlay_opened',
      beforeClose: 'modal__overlay_closing'
    },
    className: {
      base: 'modal__dialog',
      afterOpen: 'modal__dialog_opened',
      beforeClose: 'modal__dialog_closing'
    },
    contentLabel: ariaContentLabel,
    aria: ariaContentLabelledBy ? {
      labelledby: ariaContentLabelledBy
    } : undefined,
    onAfterOpen: onAfterOpen,
    onRequestClose: onRequestClose,
    onAfterClose: onAfterClose
  }, children);
};
Modal.setAppElement = _reactModal["default"].setAppElement;
Modal.Title = _modalTitle["default"];
Modal.Header = _modalHeader["default"];
Modal.Body = _modalBody["default"];
var _default = exports["default"] = Modal;